export const ListQueryKey = 'notifylist';
export const DetailQueryKey = 'notify';
export const Urls = {
  selectUrl: '/notify/list',
  updateUrl: '/notify/update',
  deleteUrl: '/notify/delete',
  createUrl: '/notify/create',
  detailUrl: '/notify/detail'
};